// extracted by mini-css-extract-plugin
export default {"container":"Home_container__QdnP9","text":"Home_text__6VeGj","skills":"Home_skills__nHpUt","shine":"Home_shine__75O7f"};